<template>
  <rect width="4" height="20" rx="1" fill="#DBDDE1" />
  <path
    d="M0 12H4V19C4 19.5523 3.55228 20 3 20H1C0.447715 20 0 19.5523 0 19V12Z"
    fill="#FF9F04"
  />
</template>
